module.exports = __webpack_public_path__ + "img/flutterwave.06ab0288.png";